import StyleModel from './StyleModel';

export {
    StyleModel
};



// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/models/index.js